<template>
	<div class="socials">
		<a
			v-for="medium in socials"
			:key="medium.ID"
			:class="medium.platform"
			:href="medium.url"
			:aria-label="medium.platform"
			target="_blank"
		>
			<font-awesome-icon
				v-if="!['tripadvisor', 'zoover'].includes(medium.platform)"
				:icon="`fa-brands fa-square-${medium.platform}`"
				size="1x"
			/>
			<font-awesome-icon
				v-if="!['tripadvisor', 'zoover'].includes(medium.platform)"
				:icon="`fa-brands fa-${medium.platform}`"
				size="1x"
			/>
		</a>
		<a :href="`tel:${$phoneRaw(phone)}`">
			<font-awesome-icon class="icon" icon="fal fa-phone" size="1x" />
		</a>
		<a :href="`mailto:${email}`">
			<font-awesome-icon class="icon" icon="fal fa-envelope" size="1x" />
		</a>
	</div>
</template>

<script setup>
defineProps({
	socials: { type: Array, default: () => [] },
	phone: { type: String, default: '' },
	email: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.socials .tripadvisor {
	background: url('~/assets/images/tripadvisor-white.svg') no-repeat center center;
	background-size: 22px;
	width: 40px;
	height: 40px;
	line-height: 40px;
}

.socials .tripadvisor:hover {
	background: url('~/assets/images/tripadvisor-hover.svg') no-repeat center center;
	background-size: 22px;
}

.socials {
	position: fixed;
	top: 50vh;
	right: 0%;
	transform: translateY(-50%);
	display: flex;
	flex-flow: column;
	align-items: center;
	justify-content: center;
	width: 60px;
	background-color: #fff;
	z-index: 20;
	padding: 10px 0;

	a {
		position: relative;
		color: var(--subtitle-color);
		display: flex;
		align-items: center;
		justify-content: center;
		width: 40px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		font-size: 22px;
		margin: 5px;
		text-decoration: none;

		&:hover {
			color: var(--cta-color-hover);
		}
	}
}

@media (max-width: 900px) {
	.socials {
		display: none;
	}
}
</style>
